import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { RequiresAccess } from '@interxfi/design-system/access-context';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { Button } from '@interxfi/design-system/components/button';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table';
import PlusIcon from '@interxfi/design-system/icons/react/icon-plus';
import { PageTabRail } from '../../../../../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../../../components/router/router-tabbed-navigation';
import { UtcFixSessionRegisterDrawer } from '../../../../../../../../../../features/dtcc/utc-fix-session/utc-fix-session-register-drawer';
import { UtcFixSessionsTable } from '../../../../../../../../../../features/dtcc/utc-fix-session/utc-fix-sessions-table';
import { getPageHead } from '../../../../../../../../../../util/routing/meta';

export const Route = createFileRoute(
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/utc-fix-session/_utc-fix-session/',
)({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingOperationsTrade,
      label: 'UTC FIX Sessions',
      order: 1,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingOperationsTrade>,
  head: () => getPageHead('UTC FIX Sessions'),
  component: UtcFixSessionList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <PageTabRail
      actions={
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          <RequiresAccess write>
            <UtcFixSessionRegisterDrawer
              trigger={<Button affixIcon={<PlusIcon aria-hidden />} aria-label="Register UTC FIX Session" size="small" />}
            />
          </RequiresAccess>

          {filter}
        </HorizontalStack>
      }
      group={TabbedNavigationGroup.ClearingOperationsTrade}
    />
  );
}

function UtcFixSessionList() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <UtcFixSessionsTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
